import React from 'react'
import PropTypes from 'prop-types'

import {
  Box,
  Button,
  Card,
  Chip,
  Grid,
  LinearProgress,
  Typography,
  makeStyles,
} from '@material-ui/core'

import { reverse } from 'named-urls'
import { routes } from 'Routes'
import { useHistory } from 'react-router-dom'

import { QuestionBox } from './components'

import styles from './styles'
import constants from 'constants/index'

const useStyles = makeStyles(styles)

const QuestionnaireCard = ({ questionnaire, tourStep }) => {
  const classes = useStyles()
  const history = useHistory()

  const handleReply = () => {
    history.push(
      reverse(routes.dponetQuestionnaire.reply, {
        questionnaireId: questionnaire.id,
      }),
    )
  }

  return (
    <Grid item xs={12} md={6} lg={4} xl={3}>
      <Card className={classes.cardMain} id={tourStep}>
        <Box className={classes.cardHeader} p={2}>
          <Box className={classes.cardSubHeader}>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5" className={classes.whiteTypography}>
                {questionnaire.name}
              </Typography>
            </Box>
            {questionnaire.status ===
            constants.questionnaire.NOT_APPLICABLE_STATUS ? (
              <Box p={0.3} mt={3}>
                <Chip
                  label="Não se Aplica"
                  size="large"
                  color="secondary"
                  className={classes.notApplicableChip}
                />
              </Box>
            ) : (
              <Box>
                <Box
                  p={0.3}
                  mt={2}
                  display="flex"
                  justifyContent="space-between"
                >
                  <Typography className={classes.whiteTypography}>
                    Progresso de Resolução
                  </Typography>
                  <Typography className={classes.whiteTypography}>
                    {questionnaire.answerPercentage}%
                  </Typography>
                </Box>
                <LinearProgress
                  variant="determinate"
                  value={questionnaire.answerPercentage}
                  classes={{ barColorPrimary: classes.barColorPrimary }}
                  className={classes.determinate}
                />
              </Box>
            )}
          </Box>
        </Box>
        <QuestionBox
          questionType="Questões"
          questionLength={questionnaire?.activeQuestions}
        />
        <QuestionBox
          questionType="Respondidas"
          questionLength={questionnaire.answeredQuestions}
        />
        <QuestionBox
          questionType="Pendentes"
          questionLength={questionnaire.pendingQuestions}
        />
        <QuestionBox
          questionType="Outras Questões"
          questionLength={questionnaire.notApplicableQuestions}
        />
        <Box p={2} width="100%">
          <Button className={classes.cardButton} onClick={handleReply}>
            Responder
          </Button>
        </Box>
      </Card>
    </Grid>
  )
}

QuestionnaireCard.propTypes = {
  questionnaire: PropTypes.object,
}

export default QuestionnaireCard
